export const finalChanceData = [
  {
    id: "dad2021mpn",
    name: "LITTLE LESLEY, Tank leotard, Youth size",
    description: "Simple and comfy. Last pieces.",
    image:
      "https://cdn.shopify.com/s/files/1/0770/9592/8084/files/845528.-Photoroom_b11dab82-f277-43bd-b7a0-787342e5baf7.png?v=1757782609",
    price: "20",
  },

  {
    id: "dad2033mpn",
    name: "LITTLE ISOBEL, 1/2 Sleeve leotard, Youth size",
    description: "Unique style, few left.",
    image:
      "https://cdn.shopify.com/s/files/1/0770/9592/8084/files/845629.-Photoroom.png?v=1757782236",
    price: "20",
  },

  {
    id: "da1999lpn",
    name: "DEANA, Cap sleeve leotard",
    description: "Elegant design on sale.",
    image:
      "https://cdn.shopify.com/s/files/1/0770/9592/8084/files/831202.-Photoroom.png?v=1752417999",
    price: "40",
  },
  {
    id: "06212-2n",
    name: "KAILANI, Bolero",
    description: "Versatile and light. Final chance.",
    image:
      "https://cdn.shopify.com/s/files/1/0770/9592/8084/files/859778.-Photoroom.png?v=1752421606",
    price: "30",
  },
  {
    id: "da2043lpn",
    name: "DARLING, Tank-style Leotard",
    description: "Last edition. Don’t miss it!",
    image:
      "https://cdn.shopify.com/s/files/1/0770/9592/8084/files/853545.png?v=1757781354",
    price: "40",
  },
  {
    id: "da1932mpn",
    name: "CLAIRE, Leotard",
    description: "Modern and sleek. Few left.",
    image:
      "https://cdn.shopify.com/s/files/1/0770/9592/8084/files/792916.-Photoroom.png?v=1752421984",
    price: "20",
  },

  {
    id: "da4024mpn",
    name: "RAEGAN, Camisole leotard",
    description: "Light, fresh, final stock.",
    image:
      "https://cdn.shopify.com/s/files/1/0770/9592/8084/files/1008014.png?v=1757781662",
    price: "40",
  },

  {
    id: "dad2017mpn",
    name: "LITTLE FABIANNA Long Sleeve Leotard",
    description: "Last collection available.",
    image:
      "https://cdn.shopify.com/s/files/1/0770/9592/8084/files/845489.png?v=1757781787",
    price: "20",
  },

  {
    id: "da4042mpn",
    name: "RIVER, Long sleeve leotard",
    description: "Chic and comfy. Final stock.",
    image:
      "https://cdn.shopify.com/s/files/1/0770/9592/8084/files/970072.png?v=1757781978",
    price: "30",
  },
];
